import { LocaleSelector } from './LocaleSelector';
import { PlacementSelector } from './PlacementSelector';
import styles from './SelectSection.module.css';

const SelectSection = () => {
  return (
    <section className={styles.container}>
      <div className={styles.selectors}>
        <PlacementSelector />
        <LocaleSelector />
      </div>
    </section>
  );
};

export { SelectSection };
